import instance from 'Src/common/utilities/axios_util';
import { isEmpty } from 'lodash';

class AssetManagerHelper {
  variant = 'size_small';

  constructor(assetId, variant) {
    this.assetId = assetId;
    this.variant = variant;
  }

  getAssetPath() {
    const promise = new Promise((resolve, reject) => {
      instance
        .get(`/assets/${this.assetId}/urls`, { hideNotification: true })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
    return promise;
  }

  getVariants(size) {
    const promise = new Promise((resolve, reject) => {
      this.getAssetPath()
        .then((urls) => {
          const { variants } = urls;
          if (!isEmpty(variants)) {
            const assetSizePreferred = variants.find((val) => val.variant_type === size)?.download_url;
            const assetSizeSmall = variants.find((val) => val.variant_type === 'size_small').download_url;
            const assetSizeMedium = variants.find((val) => val.variant_type === 'size_medium').download_url;
            const assetSizeLarge = variants.find((val) => val.variant_type === 'size_large').download_url;
            resolve({
              url: assetSizePreferred || assetSizeMedium || assetSizeLarge || urls.asset.download_url,
              thumbnailUrl: assetSizeSmall || assetSizeMedium || assetSizeLarge,
            });
          } else {
            resolve({
              url: urls.asset.download_url,
              thumbnailUrl: null,
            });
          }
        })
        .catch(() => {
          reject();
        });
    });
    return promise;
  }
}

export default AssetManagerHelper;
